function toTime(value) {
  const timestamp = new Date(value).getTime()
  return Number.isNaN(timestamp) ? 0 : timestamp
}

function getContactDisplay(contact = {}) {
  return contact.display_name ||
    contact.full_name ||
    contact.name ||
    contact.email ||
    contact.formatted_phone ||
    'Unknown contact'
}

function getThreadSubject(thread = {}) {
  return thread.subject || null
}

function getChannelTitle(channel = {}) {
  return channel.display_name || channel.title || 'Unknown channel'
}

function getLatestPreview(thread = {}) {
  return thread.latest_message?.message || ''
}

export function resolveChannelViewMode(channelType) {
  if (channelType === 'EMAIL') return 'emailView'
  if (channelType === 'WA_BUSINESS') return 'whatsappView'
  return 'genericReadOnlyView'
}

export function normalizeThread(rawThread) {
  return {
    id: rawThread.id,
    status: rawThread.status,
    subject: getThreadSubject(rawThread),
    createdAt: rawThread.created_at,
    updatedAt: rawThread.updated_at,
    latestMessageAt: rawThread.latest_message_at,
    messagesCount: rawThread.messages_count || 0,
    channelType: rawThread.channel?.type || 'UNKNOWN',
    channelTitle: getChannelTitle(rawThread.channel),
    contactDisplay: getContactDisplay(rawThread.contact),
    contactAvatar: rawThread.contact?.avatar || null,
    labels: Array.isArray(rawThread.labels) ? rawThread.labels.map(item => ({
      id: item.id,
      name: item.name,
      color: item.color
    })) : [],
    latestPreview: getLatestPreview(rawThread),
    viewMode: resolveChannelViewMode(rawThread.channel?.type)
  }
}

export function normalizeThreadList(rawThreads = []) {
  return rawThreads
    .map(normalizeThread)
    .sort((a, b) => toTime(b.latestMessageAt) - toTime(a.latestMessageAt))
}

function normalizeMessageContact(contact = {}) {
  return {
    display: getContactDisplay(contact),
    email: contact.email || null,
    phone: contact.formatted_phone || null,
    avatar: contact.avatar || null,
    color: contact.color || null
  }
}

function normalizeAgent(agent) {
  if (!agent) return null

  return {
    id: agent.id,
    name: agent.name || agent.full_name || 'Unknown agent',
    email: agent.email || null,
    avatar: agent.avatar || null
  }
}

function normalizeEmailMeta(rawMessage) {
  if (!rawMessage.email_message) return null

  return {
    subject: rawMessage.email_message.subject || null,
    from: rawMessage.email_message.from || null,
    to: rawMessage.email_message.to || null,
    cc: rawMessage.email_message.cc || null,
    createdAt: rawMessage.email_message.created_at || null
  }
}

export function normalizeThreadMessage(rawMessage, thread) {
  return {
    id: rawMessage.id,
    threadId: rawMessage.ticket_id,
    type: rawMessage.type,
    bodyType: rawMessage.body_type,
    createdAt: rawMessage.created_at,
    messageText: rawMessage.message || '',
    sanitizedHtml: rawMessage.sanitized_html || rawMessage.email_message?.html || null,
    isAutoReply: rawMessage.is_auto_reply === 1,
    deliveryStatus: rawMessage.delivery?.status || null,
    contact: normalizeMessageContact(rawMessage.contact),
    agent: normalizeAgent(rawMessage.agent),
    emailMeta: normalizeEmailMeta(rawMessage),
    emailSubjectResolved: rawMessage.email_message?.subject || thread?.subject || 'No subject'
  }
}

export function normalizeThreadMessages(rawMessages = [], thread) {
  return rawMessages
    .map(message => normalizeThreadMessage(message, thread))
    .sort((a, b) => toTime(a.createdAt) - toTime(b.createdAt))
}
